import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["target", "targetStatus", "targetProgress", "targetIndicator"];
    }

    connect() {
        this.setTargetStatusAndIndicatorPosition();
        this.targetStatusTarget.style.opacity = 1;
    }

    setTargetStatusAndIndicatorPosition() {
        if (this.redrawAnimationFrame) {
            cancelAnimationFrame(this.redrawAnimationFrame);
        }

        this.redrawAnimationFrame = requestAnimationFrame(() => {
            // get element left and width
            const { left: elementLeft, width: elementWidth } = this.element.getBoundingClientRect();

            // get target left and width
            const { left: targetLeft, width: targetWidth } = this.targetTarget.getBoundingClientRect();
            const targetMiddle = targetLeft + targetWidth * this.targetTarget.dataset.progressPercentage / 100;

            // set target status left
            const targetStatusTargetWidth = this.targetStatusTarget.getBoundingClientRect().width;
            let optimalTargetStatusTargetLeft = targetMiddle - elementLeft - targetStatusTargetWidth / 2;

            if (optimalTargetStatusTargetLeft + targetStatusTargetWidth > elementWidth) {
                optimalTargetStatusTargetLeft = elementWidth - targetStatusTargetWidth;
            }

            this.targetStatusTarget.style.left = `${Math.max(optimalTargetStatusTargetLeft, 0)}px`;

            // set target indicator left
            const targetIndicatorTargetWidth = this.targetIndicatorTarget.getBoundingClientRect().width;
            let optimalTargetIndicatorTargetLeft = targetMiddle - elementLeft - targetIndicatorTargetWidth / 2;

            if (optimalTargetIndicatorTargetLeft + targetIndicatorTargetWidth > elementWidth) {
                optimalTargetIndicatorTargetLeft = elementWidth - targetIndicatorTargetWidth;
            }

            this.targetIndicatorTarget.style.left = `${Math.max(optimalTargetIndicatorTargetLeft, 0)}px`;
        });
    }

    setTargetIndicatorTransitioned() {
        this.targetIndicatorTarget.classList.add("transitioned");
    }
}